import { formatPostDate } from "../../api/blog";

// Category pill with the displayed date on the line below, above a post's
// title on both the blog list and the post page.
export function PostMeta({ post, appLang }) {
  return (
    <div className="blogMeta">
      {post.category && <span className="blogCategory">{post.category}</span>}
      <span className="blogMetaDate">{formatPostDate(post.display_date, appLang)}</span>
    </div>
  );
}
